import { Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import {
  BackendService,
  NotificationService,
  ModalService,
  ApplicationService,
} from 'beyond-util';

import { SifarnikBase } from '../sifarnici/sifarnik-base/sifarnik-base';
import { environment } from '../../../environments/environment';
import { BackendService as RtsBackendService } from '../../services/backend.service';
import { Subscription } from 'rxjs/Subscription';
import { FormCode } from '../../enums/form-code.enum';
import { FormName } from '../../enums/form-name.enum';
import { EndpointTypes } from '../../enums/enpoint-types.enum';

@Component({
  selector: 'app-kopija-verifikacije',
  templateUrl: './kopija-verifikacije.component.html',
})
export class KopijaVerifikacijeComponent extends SifarnikBase
  implements OnInit {
  public url: SafeResourceUrl;
  private _subscriptions: Subscription[] = [];
  private _abortUrl: string = environment.abortUrl;

  constructor(
    protected _backendService: BackendService,
    protected _notificationService: NotificationService,
    protected _modalService: ModalService,
    private _sanitizer: DomSanitizer,
    private _appService: ApplicationService,
    private _rtsBackendService: RtsBackendService
  ) {
    super(_backendService, _modalService, _notificationService);

    this.url = this.getSantizedURL();
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    this.sacuvajVerifikaciju();
  }

  getSacuvajPayload() {
    return this._rtsBackendService.getRequestPayload(
      FormCode.MSVER_VER,
      FormName.Verifikacija,
      EndpointTypes.GetAllEntities
    );
  }

  ngOnInit() {
    this._subscriptions.push(
      this._appService.sacuvajKopijuVerifikacije$.subscribe(res => {
        if (res.documentCode === 'VERIFIKACIJABEZASRUNLOGA') {
          this.sacuvajVerifikaciju();
        }
      })
    );
  }

  sacuvajVerifikaciju() {
    const payload: any = this.getSacuvajPayload();
    payload.token = sessionStorage.getItem('token');

    const payloadString = JSON.stringify(payload);
    navigator.sendBeacon(this._abortUrl, payloadString);

    this._notificationService.openNoty(
      'Verifikacija bez AsRun loga uspešno sačuvana.'
    );
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  getSantizedURL() {
    const token = sessionStorage.getItem('token');

    return this._sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.kopijaVerifikacijeUrl}?token=${token}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/kopija-verifikacije/kopija-verifikacije.component.ts